export default __webpack_public_path__ + "static/playButton-5fac97b7f117a5fb83110320b59df70e.webp";